export { default as AppLoginTemplate } from './AppLoginTemplate';
export { default as AppPasswordRecoveryTemplate } from './AppPasswordRecoveryTemplate';
export { default as PasswordRecoveryChangeTemplate } from './PasswordRecoveryChangeTemplate';
export { default as UnauthorizedTemplate } from './UnauthorizedTemplate';
export { default as PasswordChangeTemplate } from './PasswordChangeTemplate';
export { default as TwoStepAuthenticationTemplate } from './TwoStepAuthenticationTemplate';



// WEBPACK FOOTER //
// ./src/themes/default/modules/membership/pages/index.js